import styled from 'styled-components'
import Flex from 'src/components/Layout/Flex/Flex'
import { ButtonStyle } from 'src/components/Atoms/Button/Button.styles'
import { TFunctionResultChildren } from 'src/components/Core/Typography/Font/types'

export const ESigTable = styled(Flex)`
    margin: 0 0 72px;
    padding: 0;
    border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
`
export const ESigItem = styled(Flex)`
    height: 40px;
    padding: 0 0 0 16px;
    border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};
    box-sizing: border-box;

    &:first-of-type {
        border-top: none;
    }

    p {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 0 0 16px;
        border-left: 1px solid ${props => props.theme.colors.shades.neutral[1]};
        flex: 1;

        &:first-of-type {
        border-left: none;
        }
    }
`

export const ESigModal = styled(Flex)`
    position: absolute;
    top: 20%;
    left: 50%;
    z-index: 2;
    width: 680px;
    min-height: 300px;
    transform: translate(-300px, 0);
    background-color: ${props => props.theme.colors.main.blank};

    span {
        width: 616px;
        height: 1px;
        margin-bottom: 24px;
        background-color: ${props => props.theme.colors.shades.neutral[0]};
    }

    ${ButtonStyle} {
        padding: 14px 16px;

        &:nth-of-type(2) {
            margin-right: 32px;
        }
    }
`
// this is the same as in equity summary for the dashboard, so when either goes to develop just import in the other to re use it
export const ModalTitle = styled('p')<TFunctionResultChildren>`
    height: 84px;
    width: 100%;
    padding: 0 0 0 30px;
    margin: 0 0 24px 0;
    background-color: ${props => props.theme.colors.main.backgroundDark};
    color: ${props => props.theme.colors.main.blank};
    font-family: ${props => props.theme.font?.family[1]};
    font-size: 32px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
`

export const FileDetails = styled(Flex)`
    padding: 0 0 0 67%;
    box-sizing: border-box;
    border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};

    & > div {
        margin-bottom: 8px;
    }
    & > div:first-child {
        margin-top: 8px;
    }
    & > div:last-child {
        margin-bottom: 16px;
    }
`

export const IconWrapper = styled(Flex)`
    border-radius: 50%;
    background-color: ${props => props.theme.colors.main.green};
    justify-content: center;
    align-items: center;
`
